import { Box, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import { useDashboardCrm } from '@/features/crm/api/dashboardCrm';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import ColumnChartBillingHistoryDash from '@/components/Base/ColumnChartBillingHistoryDash';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import { TitlePages } from '@/components/Base/TitlePage';

export const CrmDashboard = ({ title }) => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [totalMatricula, setTotalMatricula] = useState(0);
  const [totalNaoMatricula, setTotalNaoMatricula] = useState(0);
  const [selectedStartDate, setSelectedStartDate] = useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = useState(endDate);

  const { data: columns = {}, isFetched, refetch: refetchDashboard } = useDashboardCrm(selectedStartDate, selectedEndDate);

  useEffect(() => {
    if (isFetched && columns.total_matricula && columns.total_nao_matricula) {
      const matriculaTotal = columns.total_matricula.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.total;
      }, 0);

      const naoMatriculaTotal = columns.total_nao_matricula.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.total;
      }, 0);

      setTotalMatricula(matriculaTotal);
      setTotalNaoMatricula(naoMatriculaTotal);
    }
  }, [isFetched, columns]);


  return (
    <>
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <TitlePages title={title}/>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        <Stack flexDirection={'row'} flexWrap={'wrap'} gap={'8px'}>
          <KpiComponent title={'Quantidade de alunos matriculados'} value={totalMatricula.toString()} />
          <KpiComponent title={'Quantidade de alunos não matriculados'} value={totalNaoMatricula.toString()} />
        </Stack>
        {columns && 
        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={6}>
            <ColumnChartBillingHistoryDash
              categoryName={'Matriculado'}
              color={'#15AB51'}
              title={'Quantidade de alunos matriculados'}
              labelColor={'#DDDDDD'}
              data={columns.total_matricula}
            />
            <Box marginTop={'10px'}>
              <PeriodFilterDash
                startDate={selectedStartDate}
                endDate={selectedEndDate}
                onStartDateChange={setSelectedStartDate}
                onEndDateChange={setSelectedEndDate}
                refetchDashboard={refetchDashboard}
                listYears={[]}
                setSelectedYear={()=> null}
                setSelectedMonth={()=> null}
                selectedYear={() => {}}
                selectedMonth={() => {}}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <ColumnChartBillingHistoryDash
              color={'#F6BE33'}
              categoryName={'Não Matriculado'}
              title={'Quantidade de alunos não matriculados'}
              labelColor={'#DDDDDD'}
              data={columns.total_nao_matricula}
            />
            <Box marginTop={'10px'}>
              <PeriodFilterDash 
                startDate={selectedStartDate}
                endDate={selectedEndDate}
                onStartDateChange={setSelectedStartDate}
                onEndDateChange={setSelectedEndDate}
                refetchDashboard={refetchDashboard}
                listYears={[]}
                setSelectedYear={()=> null}
                setSelectedMonth={()=> null}
                selectedYear={() => {}}
                selectedMonth={() => {}}

              />
            </Box>
          </Grid>
        </Grid>
        }
      </Box>
    </>
  );
};

export default CrmDashboard;
